// SECCIÓN SECTORES //
jQuery_T4NT(document).ready(function ($) {
  const lista = document.querySelectorAll("ul.list-unstyled.sector li");
  const ul = document.querySelector(".list-unstyled.sector");
  if (ul) ul.classList.add("sector-grid");

  lista.forEach((li) => {
    const textoOriginal = li.textContent?.trim();
    if (!textoOriginal) return;

    const texto = textoOriginal.replace(/['"`‘’“”]/g, "").trim();

    const slug = texto
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ñ/g, "n")
      .replace(/\s+/g, "-")
      .replace(/\//g, "")
      .replace(/[^a-z0-9\-]/g, "");

    const img = document.createElement("img");
    img.src = "/cdn/shop/t/5/assets/icono-" + slug + ".svg";
    img.alt = `Icono ${texto}`;
    img.classList.add("sector-icon"); // Usa clase en lugar de inline style

    li.classList.add("sector-item");

    const span = document.createElement("span");
    const palabras = texto.split(" ");
    span.appendChild(document.createTextNode(palabras[0]));
    if (palabras.length > 1) {
      span.appendChild(document.createElement("br"));
      span.appendChild(document.createTextNode(palabras.slice(1).join(" ")));
    }

    li.innerHTML = "";
    li.appendChild(img);
    li.appendChild(span);
  });
});

// GENERACIÓN DE PDF //
document.addEventListener("DOMContentLoaded", function () {
  const { jsPDF } = window.jspdf;

  document.querySelectorAll('[id^="downloadPDF-"]').forEach((button) => {
    button.addEventListener("click", function () {
      const doc = new jsPDF();
      const margin = 20;
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      const productTitle = button.getAttribute("data-title") || "Producto";
      const productDescription = button.getAttribute("data-description") || "";
      const productImage = button.getAttribute("data-image") || "";

      const skuElement = document.querySelector(".t4s-sku-value");
      const sku = skuElement ? skuElement.textContent.trim() : null;

// === EXTRACCIÓN DE DATOS DE LAS TABS (DINÁMICA) === //

// Función auxiliar: busca una pestaña por texto parcial y devuelve su contenido
function findTabContentByTitle(titleText) {
  const needle = titleText.toLowerCase();

  // Modo "tab": busca en la barra de pestañas horizontal
  const tabLinks = document.querySelectorAll('.t4s-tabs-ul a');
  for (const link of tabLinks) {
    if (link.textContent.trim().toLowerCase().includes(needle)) {
      const href = link.getAttribute("href");
      if (href) return document.querySelector(href);
    }
  }

  // Modo "accordion": busca en los títulos de acordeón
  const accLinks = document.querySelectorAll('.t4s-tab__title');
  for (const link of accLinks) {
    const textEl = link.querySelector('.t4s-tab__text') || link;
    if (textEl.textContent.trim().toLowerCase().includes(needle)) {
      const href = link.getAttribute("href");
      if (href) return document.querySelector(href);
    }
  }

  return null;
}

// 1️⃣ Especificaciones Técnicas
let specs = [];
const specsContent = findTabContentByTitle("especificaciones");
if (specsContent) {
  const table = specsContent.querySelector("table");
  if (table) {
    const rows = table.querySelectorAll("tbody tr");
    specs = Array.from(rows)
      .map((row) => {
        const th = row.querySelector("th");
        const tds = row.querySelectorAll("td");
        if (th) {
          return [th.textContent.trim().toUpperCase(), ""];
        } else if (tds.length === 2) {
          return [tds[0].textContent.trim(), tds[1].textContent.trim()];
        } else {
          return ["", ""];
        }
      })
      .filter(([name, value]) => name && (value || name));
  }
}

// 2️⃣ Accesorios Estándar
let equipment = [];
const equipContent = findTabContentByTitle("accesorios");
if (equipContent) {
  const table = equipContent.querySelector("table");
  if (table) {
    const rows = table.querySelectorAll("tbody tr td");
    equipment = Array.from(rows)
      .map((td) => td.textContent.trim())
      .filter((text) => text.length > 2);
  } else {
    // si no hay tabla, extraer texto simple
    const textItems = equipContent.innerText
      .split("\n")
      .map((t) => t.trim())
      .filter((t) => t.length > 2);
    equipment = textItems;
  }
}

// 3️⃣ Sectores
let sectors = [];
const sectorsContent = findTabContentByTitle("sectores");
if (sectorsContent) {
  const sectorItems = sectorsContent.querySelectorAll(".sector-item span");
  sectors = Array.from(sectorItems).map((el) =>
    el.innerText.replace(/\s+/g, " ").trim()
  );
}

      const logo = new Image();
      const productImg = new Image();
      logo.crossOrigin = productImg.crossOrigin = "Anonymous";
      logo.src =
        "https://hellermaquinaria.com/cdn/shop/files/logo_hellermaquinaria.jpg?v=1728396040";
      productImg.src = productImage;

      Promise.allSettled([
        new Promise((resolve) => (logo.onload = resolve)),
        new Promise((resolve) => (productImg.onload = resolve)),
      ]).then(() => generatePDF());

      function generatePDF() {
        let yPosition = 30;

        // Página 1
        doc.setFont("helvetica", "bold");
        doc.setFontSize(20);
        doc.text(productTitle, margin, yPosition + 20);

        if (sku) {
          doc.setFontSize(10);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100);
          doc.text(`Código SKU: ${sku}`, margin, yPosition + 30);
        }

        // Imagen del producto
        const imgWidth = productImg.naturalWidth;
        const imgHeight = productImg.naturalHeight;
        const maxWidth = pageWidth - 2 * margin;
        const maxHeight = 100;
        let scale = Math.min(maxWidth / imgWidth, maxHeight / imgHeight);
        const displayWidth = imgWidth * scale;
        const displayHeight = imgHeight * scale;
        const xCenter = (pageWidth - displayWidth) / 2;

        doc.addImage(
          productImg,
          "JPEG",
          xCenter,
          yPosition + 50,
          displayWidth,
          displayHeight
        );

        // --- TEXTO ADVERTENCIA ORIENTATIVO EN LA PRIMERA PÁGINA ---
        doc.setFont("helvetica", "italic");
        doc.setFontSize(8);
        doc.setTextColor(120); // Color gris oscuro
        const disclaimerText = "Las imágenes incluidas en esta oferta tienen carácter orientativo. Nos reservamos el derecho a modificar el acabado o aspecto exterior de las máquinas sin previo aviso, siempre que ello no afecte a sus características técnicas ni a su funcionamiento.";
        // Dividir el texto para que se ajuste automáticamente al ancho de la página
        const disclaimerLines = doc.splitTextToSize(disclaimerText, pageWidth - 2 * margin);
        // Pintarlo a 25 mm del final de la hoja (justo arriba del pie de página rojo)
        doc.text(disclaimerLines, margin, pageHeight - 25);
        // -----------------------------------------------------------

        // Página 2: Descripción
        if (productDescription) {
          doc.addPage();
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.text("Descripción del producto:", margin, 40);

          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          const descLines = doc.splitTextToSize(
            productDescription,
            pageWidth - 2 * margin
          );

          let y = 50;
          for (const line of descLines) {
            if (y + 6 > pageHeight - margin) {
              doc.addPage();
              y = margin;
            }
            doc.text(line, margin, y);
            y += 6;
          }
        }

        // Página 3: Especificaciones Técnicas (en tabla)
        if (specs.length > 0) {
          doc.addPage();
          const tableStartY = 45;

          // Título primera vez
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.text("Especificaciones Técnicas:", margin, 40);

          doc.autoTable({
            startY: tableStartY,
            body: specs,
            theme: "striped",
            styles: {
              fontSize: 8,
              cellPadding: 2,
              overflow: "linebreak",
              halign: "left",
              valign: "middle",
            },
            columnStyles: {
              0: { fontStyle: "bold", cellWidth: "50%" },
              1: { cellWidth: "50%" },
            },
            margin: {
              top: 45, // primera página empieza aquí
              left: margin,
              right: margin,
              bottom: margin,
            },
            tableWidth: "auto",
            showHead: "never",
            pageBreak: "auto",

            // este se dispara al crear una nueva página
            didDrawPage: function (data) {
              if (data.pageNumber > 1) {
                doc.setFont("helvetica", "bold");
                doc.setFontSize(12);
                doc.text(
                  "Especificaciones Técnicas (continuación):",
                  margin,
                  40
                );
              }
            },
          });
        }

        // Página 4: Equipamiento
        if (equipment.length > 0) {
          doc.addPage();
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.text("Accesorios Estándar:", margin, 40);

          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          let y = 50;

          for (const item of equipment) {
            const cleanItem = item.replace(/^[•.,]\s*/, "").trim();
            const formattedItem = `• ${cleanItem}`;
            const lines = doc.splitTextToSize(
              formattedItem,
              pageWidth - 2 * margin
            );

            for (const line of lines) {
              if (y + 6 > pageHeight - margin) {
                doc.addPage();
                y = margin;
              }
              doc.text(line, margin, y);
              y += 6;
            }
            y += 2;
          }
        }

        // Página 5: Sectores
        if (sectors.length > 0) {
          doc.addPage();
          doc.setFont("helvetica", "bold");
          doc.setFontSize(12);
          doc.text("Sectores de Aplicación:", margin, 40);

          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);
          const capitalize = (text) =>
            text
              .toLowerCase()
              .split(" ")
              .map((w, i) =>
                ["de", "del", "la", "el", "y", "en", "a"].includes(w) && i !== 0
                  ? w
                  : w.charAt(0).toUpperCase() + w.slice(1)
              )
              .join(" ");

          const capitalizedSectors = sectors.map(capitalize);
          const half = Math.ceil(capitalizedSectors.length / 2);
          const col1 = capitalizedSectors.slice(0, half);
          const col2 = capitalizedSectors.slice(half);
          const col1X = margin;
          const col2X = pageWidth / 2 + margin / 2;
          let y = 50;
          const lineHeight = 6;

          for (let i = 0; i < Math.max(col1.length, col2.length); i++) {
            if (y + lineHeight > pageHeight - margin) {
              doc.addPage();
              y = margin;
            }
            if (col1[i]) doc.text(`• ${col1[i]}`, col1X, y);
            if (col2[i]) doc.text(`• ${col2[i]}`, col2X, y);
            y += lineHeight;
          }
        }

        // Header & Footer en todas las páginas
        const totalPages = doc.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          doc.setPage(i);
          // Header
          doc.setFillColor(255, 255, 255);
          doc.rect(0, 0, pageWidth, 30, "F");
          doc.addImage(logo, "JPEG", margin, 10, 40, 10);
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");
          doc.setTextColor(100, 103, 125);
          doc.text(
            "Heller Máquina Herramienta, S.L.\nCalle Blanco Macael, s/n\n03670 Monforte del Cid, Alicante (España)\nTeléfono: +34 965 430 014",
            pageWidth - margin,
            15,
            { align: "right" }
          );

          // Footer
          const footerY = pageHeight - 15;
          doc.setFillColor(98, 19, 40);
          doc.rect(0, footerY, pageWidth, 15, "F");
          doc.setFontSize(8);
          doc.setTextColor(255);
          doc.text("www.hellermaquinaria.com", margin, footerY + 7);
          doc.text(
            `Página ${i} de ${totalPages}`,
            pageWidth - margin,
            footerY + 7,
            {
              align: "right",
            }
          );
        }

        doc.save(productTitle + ".pdf");
      }
    });
  });
});
